import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

import { BlockType } from '@/types/database';
import { blockRegistry, blockTypes, type BlockRegistryEntry } from '@/components/blocks/registry';

interface AddBlockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddBlock: (blockType: BlockType) => void;
}

const SECTIONS: { category: BlockRegistryEntry<unknown>['category']; heading: string; description: string }[] = [
  { category: 'component', heading: 'Components', description: 'Thin, directly-configurable MUI components.' },
  { category: 'widget', heading: 'Widgets', description: 'Pull in your unit’s other platform data.' },
];

export function AddBlockDialog({ open, onOpenChange, onAddBlock }: AddBlockDialogProps) {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} fullWidth maxWidth="sm">
      <DialogTitle>Add a Block</DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          {SECTIONS.map((section) => {
            const types = blockTypes.filter((type) => blockRegistry[type].category === section.category);
            if (types.length === 0) return null;

            return (
              <Stack key={section.category} spacing={1.25}>
                <Stack spacing={0.25}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{section.heading}</Typography>
                  <Typography variant="caption" color="text.secondary">{section.description}</Typography>
                </Stack>
                {types.map((type) => {
                  const entry = blockRegistry[type];
                  const Icon = entry.icon;
                  return (
                    <Button
                      key={type}
                      variant="outlined"
                      onClick={() => onAddBlock(type)}
                      startIcon={<Icon size={20} />}
                      sx={{ justifyContent: 'flex-start', py: 1.25 }}
                    >
                      <Stack spacing={0.25} sx={{ alignItems: "flex-start" }}>
                        <Typography sx={{ fontWeight: 600 }}>{entry.label}</Typography>
                        <Typography variant="caption" color="text.secondary">{entry.description}</Typography>
                      </Stack>
                    </Button>
                  );
                })}
              </Stack>
            );
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
